import React from "react";

export type IdmsDataContextValue = Record<string, never>;

const defaultValue: IdmsDataContextValue = {};

export const IdmsDataContext = React.createContext<IdmsDataContextValue>(defaultValue);

export const useIdmsData = () => React.useContext(IdmsDataContext);
